// components/MobileLanguageToggle.tsx
'use client';

import { useState } from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { setLocaleCookie } from '@/utils/localeCookiesManager.client';
import IconCorrect from '@/context/global/components/Icon/IconCorrect';
import IconArrowUp from '@/context/global/components/Icon/IconArrowUp';
import { CWLanguageChangeConfirm } from '@/context/global/components/g00/g00-d00-g020-cw-language-change-confirm';
import { useAuthStore } from '@/context/global/stores/authStore';

export default function CWLocaleToggleButtonMobile() {
  const t = useTranslations('LocaleToggle');
  const currentLocale = useLocale();
  const clientType = useAuthStore((state) => state.clientType);
  const [isOpen, setIsOpen] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingLocale, setPendingLocale] = useState<'th' | 'en' | null>(null);

  const handleLanguageChange = (newLocale: 'th' | 'en') => {
    if (newLocale === currentLocale) {
      setIsOpen(false);
      return;
    }

    setIsOpen(false);

    // For website users, change language directly without modal
    if (clientType === 'website') {
      setLocaleCookie(newLocale);
      window.location.reload();
      return;
    }

    // For mobile app users, show confirmation modal
    setPendingLocale(newLocale);
    setShowConfirm(true);
  };

  const handleConfirmChange = () => {
    if (pendingLocale) {
      setLocaleCookie(pendingLocale);
      window.location.reload();
    }
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex w-full items-center justify-between py-3 pr-12 text-left text-2xl text-white"
      >
        {t('language')}
        <IconArrowUp
          className={`transition-transform duration-200 ${isOpen ? 'rotate-0' : 'rotate-180'}`}
        />
      </button>

      {isOpen && (
        <div className="mt-1 flex w-full flex-col gap-2 px-5">
          <div className="relative flex gap-2">
            {currentLocale === 'th' && (
              <IconCorrect className="absolute left-2 top-1.5 size-8 text-ais-green" />
            )}
            <button
              onClick={() => handleLanguageChange('th')}
              className={`w-full rounded-[8px] bg-[#0B0B0B] p-2 pl-14 text-left text-xl font-semibold ${currentLocale === 'th' ? 'text-ais-green' : 'text-white'}`}
            >
              {t('thai')}
            </button>
          </div>

          <div className="relative flex gap-2">
            {currentLocale === 'en' && (
              <IconCorrect className="absolute left-2 top-1.5 size-8 text-ais-green" />
            )}
            <button
              onClick={() => handleLanguageChange('en')}
              className={`w-full rounded-[8px] bg-[#0B0B0B] p-2 pl-14 text-left text-xl font-semibold ${currentLocale === 'en' ? 'text-ais-green' : 'text-white'}`}
            >
              {t('english')}
            </button>
          </div>
        </div>
      )}

      <CWLanguageChangeConfirm
        isOpen={showConfirm}
        onClose={() => {
          setShowConfirm(false);
          setPendingLocale(null);
        }}
        onConfirm={handleConfirmChange}
      />
    </div>
  );
}
